import { HippoApiService } from 'services/hippoApi';

function getElementString(e: Element) {
    const id = e.getAttribute('id');
    const classes = (e.getAttribute('class') || '').split(' ').join('.');
    const element = e.tagName.toLowerCase();
    return element + (id && id.length > 0 ? '#' + id : '') + (classes && classes.length > 0 ? '.' + classes : '');
}

import * as angular from 'angular';
import { ILocationService } from 'angular';
import * as _ from 'lodash';

export const module = angular.module('clickTrackingService', []);

export class ClickTrackingService {
    private hippoApiService: HippoApiService;
    private $location: ILocationService;
    private $stateParams: StateParams;

    constructor(hippoApiService: HippoApiService, $location: ILocationService, $stateParams: StateParams) {
        this.hippoApiService = hippoApiService;
        this.$location = $location;
        this.$stateParams = $stateParams;
    }

    trackClick(event: JQueryEventObject) {
    }

    trackAllButtonAndLinkClicks() {
        const buttonAndLinkTags = ['hippo-button', 'button', 'a'];

        angular.element(document.body).on('click', (event: JQueryEventObject) => {
            const tagName = event.target.tagName.toLowerCase();
            if (_.includes(buttonAndLinkTags, tagName)) {
                this.trackClick(event);
            }
        });
    }
}

module.factory('clickTrackingService', function(
    hippoApiService: HippoApiService,
    $location: ILocationService,
    $stateParams: StateParams
) {
    'ngInject';

    const clickTrackingService = new ClickTrackingService(hippoApiService, $location, $stateParams);

    clickTrackingService.trackAllButtonAndLinkClicks();

    return clickTrackingService;
});
